module.exports = __webpack_public_path__ + "static/media/screen.7b6f788c.png";